export const RD_FORM_ID = 'proxpect-form-newsletter-duplicado-fd1d51989b04fea3e8ce';
export const RD_FORM_ID_EMBEDDED = 'proxpect-form-newsletter-paginas-internas-1ff142abeb15fb4f6fb3';
export const RD_DUVIDA_FORM_ID = 'cadastro-lp-eb41e34286b9140c1eaa';
export const RD_GA_CODE = 'UA-123872829-6';
export const RD_FORM_SCRIPT = 'https://d335luupugsy2.cloudfront.net/js/rdstation-forms/stable/rdstation-forms.min.js';
